import React, { useEffect, useState } from "react";
// react-pivottable UI
import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";

/*
  CompanyPivotTable
  Props:
    - data: array of company objects (as returned by API)
  Notes:
    - transform each company object into a flat row object with readable keys
    - PivotTableUI expects data as array of objects or array of arrays; we use array of objects
*/
const CompanyPivotTable = ({ data = [] }) => {
  const transformData = (companies = []) =>
    companies.map((c) => ({
      Name: c.name || "",
      Email: c.email || "",
      Rank: c.rank || "",
      Location: c.location || "",
      CreatedBy: c.ownerfullname || "",
      City: c.city || "",
      State: c.state || "",
      Country: c.country || "",
      Zipcode: c.zipcode || "",
      Type: c.companytypename || "",
      Phone: c.phone || "",
      Team: c.membercount || "",
      CreatedDate: c.createddate || "",
      Labels: c.tagstring || "",
      Billing: c.billing || "",
      Classification: c.classificationname || "",
      NumberOfEmployees: c.noofemployees || "",
    }));

  const rows = transformData(data);

  const [pivotState, setPivotState] = useState({
    data: rows,
    rows: [],
    cols: ["Type"],
    aggregatorName: "Count",
    vals: ["Name"],
    rendererName: "Table",
  });

  // keep pivot data in sync when incoming data changes
  useEffect(() => {
    setPivotState((prev) => ({ ...prev, data: rows }));
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    // card-like full width container for a professional look
    <div
      className="company-pivot-wrapper"
      style={{
        width: "100%",
        background: "#ffffff",
        border: "1px solid rgba(0,0,0,0.08)",
        borderRadius: 8,
        padding: 16,
        boxShadow: "0 2px 8px rgba(16,24,40,0.06)",
        boxSizing: "border-box",
      }}
    >
      {/* header area for pivot (keeps UI professional and separated) */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 12,
        }}
      >
        <h6
          style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "#111827" }}
        >
          Companies Pivot View
        </h6>
        <small style={{ color: "#6b7280" }}>
          Drag fields to rows/columns — renderer: {pivotState.rendererName}
        </small>
      </div>

      {/* make the pivot area scrollable and full width */}
      <div
        style={{
          width: "100%",
          overflow: "auto",
          maxHeight: "70vh",
          paddingTop: 8,
        }}
      >
        <PivotTableUI
          {...pivotState}
          data={rows}
          onChange={(s) => setPivotState(s)}
          unusedOrientationCutoff={Infinity}
          rendererOptions={{
            table: {
              // small table tweaks - keep rows compact
              rowClassName: "pvtTableRow",
            },
          }}
        />
      </div>
    </div>
  );
};

export default CompanyPivotTable;
